import { Col, Input } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import HeadingBack from "../component/HeadingBack";
import { allapiAction } from "../../Redux/common/action";
import { URL } from "../../Redux/common/url";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { toast } from "react-toastify";

function UserDetailspassword() {
  const dispatch = useDispatch();
  const data = useParams();

  const details = useSelector((state) =>
    state?.allapi?.get_profile ? state?.allapi?.get_profile : {}
  );

  useEffect(() => {
    dispatch(allapiAction.getprofile({ uid: data?.id }));

    return () => {};
  }, []);

  console.log(details);

  const [statusselect, setstatusselect] = useState("");
  const [statusselectreas, setstatusselectreas] = useState("");

  console.log(statusselect);
  console.log(statusselectreas);

  const hendleTochangedata1 = (e) => {
    const { name, value } = e.target;

    setstatusselect({ ...statusselect, [name]: value });
  };
  const hendletoupdateusername = async () => {
    if (!statusselect?.email) {
      toast.error("please enter user name");
    } /*  else if (!statusData?.newpassword) {
      toast.error("please enter new password");
    } else if (!statusData?.confirmpassword) {
      toast.error("please enter confirm password");
    } else if (statusData?.newpassword !== statusData?.confirmpassword) {
      toast.error("password not match");
    } */ else {
      // const response = await dispatch(
      //   allapiAction.editusernmaeByadmin({
      //     fullName: statusselect?.email,
      //     // newPassword: statusData?.newpassword,
      //   })
      // );

      // if (response?.success) {
      //   dispatch(allapiAction.getprofile({ uid: data?.id }));
      // }

      return () => {};
    }
  };
  // useEffect(() => {
  //   setstatusselect(details);
  //   // setstatusselectreas(details?.accountId?.reason);
  // }, [details]);

  const [show, setShow] = useState(false);
  const [showcupdate, setShowUpdate] = useState(false);
  const [dataimg, setdataimg] = useState("");

  const handleClose = () => {
    setdataimg("");
    setShow(false);
  };
  const handleCloseUpdate = () => {
    // setdataimg('')
    setShowUpdate(false);
  };
  const handleShow = () => {
    setShow(true);
    // setdataimg("")
  };

  const hendleimgView = (e) => {
    setdataimg(e);
    setShow(true);
  };

  const hendletosubmitVerify = (e) => {
    // verifykeyByAdmin
    setShowUpdate(true);
    // dispatch(allapiAction.verifykeyByAdmin({_id: details?._id, keyverify: e}))

    return () => {};
  };

  const hendlesubmitup = () => {
    setShowUpdate(false);
    dispatch(
      allapiAction.verifykeyByAdmin({
        _id: details?._id,
        keyverify: statusselect,
        reason: statusselectreas,
      })
    );

    return () => {};
  };

  const [statusData, setstatusData] = useState({});

  const hendleTochangedata = (e) => {
    const { name, value } = e.target;

    setstatusData({ ...statusData, [name]: value });
  };
  const hendletopasswordchange = () => {
    if (!statusData?.oldpassword) {
      toast.error("please enter old password");
    } else if (!statusData?.newpassword) {
      toast.error("please enter new password");
    } else if (!statusData?.confirmpassword) {
      toast.error("please enter confirm password");
    } else if (statusData?.newpassword !== statusData?.confirmpassword) {
      toast.error("password not match");
    } else {
      dispatch(
        allapiAction.selfpasswordChangeadmin({
          password: statusData?.oldpassword,
          newPassword: statusData?.newpassword,
        })
      );

      return () => {};
    }
  };

  return (
    <div className=" code-box">
      <div className="flex">
        <div>
          <HeadingBack
            title={"Profile"}
            // subHeading={`Total ${users_list?.totalDocs || 0} Users`}
          />
        </div>
        <Col md={5} sm={5} xs={12} className="pl-5  ml-5">
          {/* <Input
            type="text"
            autoComplete="new-off"
            className="form-control"
            onChange={(e) => handleChange(e.target.value)}
            placeholder="Search..."
            // value={values?.TestCode}
          /> */}
          {/* <AsyncPaginate
            // key={managerKey}
            value={seleceteManger}
            loadOptions={loadOptionsgetManager}
            onChange={setseleceteManger}
            additional={{
              page: 1,
            }}
          /> */}
        </Col>

        {/* <div className="flex1 flex justify-content-end align-items-center">
          <Tooltip title="Add">
            <span className="jop_btn" onClick={() => navigate("/user/add")}>
              Add
              <SvgIcon.Add width={40} height={40} className="cursor-pointer" />
            </span>
          </Tooltip>
        </div> */}
      </div>

      <Modal show={show} onHide={handleClose}>
        {/* <Modal.Header closeButton>
          <Modal.Title>Modal heading</Modal.Title>
        </Modal.Header> */}
        <img
          style={{ width: "100%" }}
          src={URL.API_BASE_URL + dataimg}
          alt=""
        />

        {/* <Modal.Body>Woohoo, you're reading this text in a modal!</Modal.Body> */}
        {/* <Modal.Footer>
          <Button variant='secondary' onClick={handleClose}>
            Close
          </Button>
          <Button variant='primary' onClick={handleClose}>
            Save Changes
          </Button>
        </Modal.Footer> */}
      </Modal>

      <Modal show={showcupdate} onHide={handleCloseUpdate}>
        <Modal.Header closeButton>
          <Modal.Title>Approve</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="px-7 py-5">
            <div className="mb-10">
              <label className="form-label fw-semibold">approve:</label>

              <div>
                <select
                  className="form-select "
                  data-kt-select2="true"
                  data-placeholder="Select option"
                  data-dropdown-parent="#kt_menu_637dc7729cedd"
                  data-allow-clear="true"
                  value={statusselect}
                  onChange={(e) => {
                    setstatusselect(e.target.value);
                  }}
                >
                  {/* <option></option> */}
                  <option value="pending">Pending</option>
                  <option value="reject">Rejected</option>
                  {/* <option value='complete'>In Process</option> */}
                  <option value="complete">Complete</option>
                </select>
              </div>

              {/* statusselect */}
              {/* <!--end::Input-->  */}
            </div>
          </div>
          {statusselect == "reject" && (
            <div className="px-7 py-5">
              <div className="mb-10">
                <label className="form-label fw-semibold">Reason:</label>

                <div>
                  <input
                    className="form-control bg-transparent"
                    value={statusselectreas}
                    onChange={(e) => {
                      setstatusselectreas(e.target.value);
                    }}
                  />
                </div>
              </div>
            </div>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleCloseUpdate}>
            Close
          </Button>
          <Button variant="primary" onClick={hendlesubmitup}>
            Save Changes
          </Button>
        </Modal.Footer>
      </Modal>

      <div className="tableResponsive mt-10  code-box">
        <div className="d-flex flex-column flex-column-fluid">
          {/* <!--begin::Toolbar-->  */}
          <div id="kt_app_toolbar" className="app-toolbar py-3 py-lg-6">
            {/* <!--begin::Toolbar container-->  */}
            <div
              id="kt_app_toolbar_container"
              className="app-container container-xxl d-flex flex-stack"
            >
              {/* <!--begin::Page title-->  */}
              <div className="page-title d-flex flex-column justify-content-center flex-wrap me-3">
                {/* <!--begin::Title-->  */}
                <h1 className="page-heading d-flex text-dark fw-bold fs-3 flex-column justify-content-center my-0">
                  Manage Profile
                </h1>
              </div>
              {/* <!--end::Page title-->  */}
              {/* <!--begin::Actions-->  */}
            </div>
            {/* <!--end::Toolbar container-->  */}
          </div>

          {/* <div id="kt_app_content" className="app-content flex-column-fluid">
          
            <div
              id="kt_app_content_container"
              className="app-container container-xxl"
            >
              
              <div className="card card-flush">
                 
                <div className="card-header mt-6">
                
                  <div className="card-title"></div>
                   
                  <div className="card-toolbar"></div>
                </div>
             
                <div className="card-body pt-0">
                  <div className="row">
                    <div className="col-4">
                      <div className="row">
                        <div className="col-2">
                          <img src="" alt="" />
                        </div>
                        <div className="col-10">
                          <p>{details?.uid}</p>
                          <p>{details?.number}</p>
                        </div>
                      </div>
                    </div>
                    <div className="col-4">
                      <div className="row">
                        <div className="col-6">Balence</div>
                        <div className="col-6">
                          {details?.walletId?.closeBal} ₹
                        </div>
                      </div>
                    </div>
                    <div className="col-4">
                      <div className="row">
                        <div className="col-6">Loss</div>
                        <div className="col-6">verify</div>
                      </div>
                    </div>
                    <div className="col-4">
                      <table className="userDetailTable">
                        <tr className="userDetailTablet">
                          <th className="userDetailTablet2">
                            Kyc Doucument Details
                          </th>
                          <th className="userDetailTablet2"></th>
                        </tr>
                        <tr>
                          <td>Doucument Name</td>
                          <td>
                            {details?.accountId?.idType == "1"
                              ? "Adhaar crad"
                              : details?.accountId?.idType == "2"
                              ? "Driveing License"
                              : "Voter Id Card"}
                          </td>
                        </tr>
                        <tr>
                          <td>Doucument Number</td>
                          <td>{details?.accountId?.idNumber}</td>
                        </tr>
                        <tr>
                          <td>Doucument Image</td>
                          <td style={{ width: "50px" }}>
                            <a
                              onClick={(e) => {
                                hendleimgView(details?.accountId?.idImage);
                              }}
                            >
                              <img
                                style={{ width: "100%" }}
                                src={
                                  URL.API_BASE_URL + details?.accountId?.idImage
                                }
                                alt=""
                              />
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td>Qr Image</td>
                          <td style={{ width: "50px" }}>
                            <a
                              onClick={(e) => {
                                hendleimgView(details?.accountId?.qrcode);
                              }}
                            >
                              <img
                                style={{ width: "100%" }}
                                src={
                                  URL.API_BASE_URL + details?.accountId?.qrcode
                                }
                                alt=""
                              />
                            </a>
                          </td>
                        </tr>
                        <tr>
                          <td>UPI </td>
                          <td>{details?.accountId?.upiId}</td>
                        </tr>

                        <tr>
                          <td>Verify Doucument status</td>
                          <td>
                            {" "}
                            <button
                              data-id="2209"
                              onClick={() => {
                                hendletosubmitVerify(
                                  details?.keyverify == "Active"
                                    ? "Inactive"
                                    : "Active"
                                );
                              }}
                              className={
                                details?.keyverify == "complete"
                                  ? "btn btn-sm btn-success ms-3 mt-3"
                                  : "btn btn-sm btn-danger ms-3 mt-3"
                              }
                            >
                              {details?.keyverify}
                             
                            </button>
                          </td>
                        </tr>
                      </table>
                    </div>
                    <div className="col-4">
                      <table className="userDetailTable">
                        <tr className="userDetailTablet">
                          <th className="userDetailTablet2">
                            Bank Account Details
                          </th>
                          <th className="userDetailTablet2"></th>
                        </tr>
                        <tr>
                          <td>Bank account holder Name</td>
                          <td>{details?.accountId?.userName}</td>
                        </tr>
                        <tr>
                          <td>Ifse Code</td>
                          <td>{details?.accountId?.ifseCode}</td>
                        </tr>
                        <tr>
                          <td>Bank Name</td>
                          <td>{details?.accountId?.bankName}</td>
                        </tr>
                        <tr>
                          <td>Account Number</td>
                          <td>{details?.accountId?.accountNumber}</td>
                        </tr>
                      </table>
                    </div>
                    <div className="col-4">
                      <table className="userDetailTable">
                        <tr className="userDetailTablet">
                          <th className="userDetailTablet2">Other Details</th>
                          <th className="userDetailTablet2"></th>
                        </tr>
                        <tr>
                          <td>Refer Code</td>
                          <td>{details?.referCode}</td>
                        </tr>
                        <tr>
                          <td>Refer by</td>
                          <td>{details?.referBy}</td>
                        </tr>
                       
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          
          </div> */}
          <div id="kt_app_content" className="app-content flex-column-fluid">
            {/* <!--begin::Content container-->  */}
            <div
              id="kt_app_content_container"
              className="app-container container-xxl"
            >
              {/* <!--begin::Card-->  */}
              <div className="card card-flush">
                {/* <!--begin::Card header-->  */}
                <div className="card-header mt-6">
                  {/* <!--begin::Card title-->  */}
                  <div className="card-title">Change Password</div>
                  {/* <!--end::Card title-->  */}
                  {/* <!--begin::Card toolbar-->  */}
                  <div className="card-toolbar"></div>
                </div>
                {/* <!--end::Card header-->  */}
                {/* <!--begin::Card body-->  */}
                {/* <div className="card-body pt-0 mt-30">
                  <div className="row mt-10">
                    <div className="col-sm-3">
                      <div className="row">
                        <lable className="text-end">User Name</lable>
                      </div>
                    </div>
                    <div className="col-sm-6 ">
                      <div className="row">
                    
                        <Col span={24}>
                          <Input
                            name="email"
                            placeholder="User name"
                            value={statusselect?.email}
                            onChange={(e) => {
                              hendleTochangedata1(e);
                            }}
                          />
                        </Col>
                      </div>
                    </div>
                  </div>
                  <div className="row mt-10">
                    <div className="col-sm-3"></div>
                    <div className="col-sm-3">
                      <button
                        data-id="2209"
                        onClick={() => {
                          hendletoupdateusername();
                        }}
                        className={"btn btn-sm btn-success ms-3 mt-3"}
                      >
                        Update
                      </button>
                    </div>
                  </div>
                </div> */}
              </div>
            </div>
            {/* <!--end::Content container-->  */}
          </div>
          <div
            id="kt_app_content"
            className="app-content flex-column-fluid mt-15"
          >
            {/* <!--begin::Content container-->  */}
            <div
              id="kt_app_content_container"
              className="app-container container-xxl"
            >
              {/* <!--begin::Card-->  */}
              <div className="card card-flush">
                {/* <!--begin::Card header-->  */}
                <div className="card-header mt-6">
                  {/* <!--begin::Card title-->  */}
                  <div className="card-title">Change Password</div>
                  {/* <!--end::Card title-->  */}
                  {/* <!--begin::Card toolbar-->  */}
                  <div className="card-toolbar"></div>
                </div>
                {/* <!--end::Card header-->  */}
                {/* <!--begin::Card body-->  */}
                <div className="card-body pt-0 mt-30">
                  <div className="row">
                    <div className="col-sm-3">
                      <div className="row">
                        <lable className="text-end">Old password</lable>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="row">
                        {/* dfjhk */}
                        <Col span={24}>
                          <Input
                            name="oldpassword"
                            placeholder="Old password"
                            value={statusData?.oldpassword}
                            onChange={(e) => {
                              hendleTochangedata(e);
                            }}
                          />
                        </Col>
                      </div>
                    </div>
                  </div>
                  <div className="row mt-10">
                    <div className="col-sm-3">
                      <div className="row">
                        <lable className="text-end">New password</lable>
                      </div>
                    </div>
                    <div className="col-sm-6">
                      <div className="row">
                        {/* dfjhk */}
                        <Col span={24}>
                          <Input
                            name="newpassword"
                            placeholder="enter New password"
                            value={statusData?.newpassword}
                            onChange={(e) => {
                              hendleTochangedata(e);
                            }}
                          />
                        </Col>
                      </div>
                    </div>
                  </div>
                  <div className="row mt-10">
                    <div className="col-sm-3">
                      <div className="row">
                        <lable className="text-end">Confirm password</lable>
                      </div>
                    </div>
                    <div className="col-sm-6 ">
                      <div className="row">
                        {/* dfjhk */}
                        <Col span={24}>
                          <Input
                            name="confirmpassword"
                            placeholder="Confirm password"
                            value={statusData?.confirmpassword}
                            onChange={(e) => {
                              hendleTochangedata(e);
                            }}
                          />
                        </Col>
                      </div>
                    </div>
                  </div>
                  <div className="row mt-10">
                    <div className="col-sm-3"></div>
                    <div className="col-sm-3">
                      <button
                        data-id="2209"
                        onClick={() => {
                          hendletopasswordchange();
                        }}
                        className={"btn btn-sm btn-success ms-3 mt-3"}
                      >
                        Update
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <!--end::Content container-->  */}
          </div>
          {/* <!--end::Content-->  */}
        </div>
      </div>
    </div>
  );
}

export default UserDetailspassword;
